// extracted by mini-css-extract-plugin
export var avatarContainer = "_g2-0";
export var avatarTypingWave = "_g2-i";
export var gray = "_g2-f";
export var green = "_g2-c";
export var icon = "_g2-9";
export var image = "_g2-1";
export var lg = "_g2-6";
export var md = "_g2-5";
export var presenceDot = "_g2-b";
export var red = "_g2-d";
export var sm = "_g2-4";
export var status = "_g2-a";
export var typingDot = "_g2-h";
export var typingPill = "_g2-g";
export var xl = "_g2-7";
export var xs = "_g2-3";
export var xxl = "_g2-8";
export var xxs = "_g2-2";
export var yellow = "_g2-e";